var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#DF553B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4992 14.7878C10.7763 14.7878 10.1849 14.1677 10.1849 13.4097V5.48554C10.1849 4.72757 10.7763 4.10742 11.4992 4.10742C12.222 4.10742 12.8135 4.72757 12.8135 5.48554V13.4097C12.8135 14.1677 12.222 14.7878 11.4992 14.7878Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 19.7148C10.5926 19.7148 9.85711 18.9436 9.85711 17.9922C9.85711 17.0408 10.5926 16.2695 11.5 16.2695C12.4073 16.2695 13.1428 17.0408 13.1428 17.9922C13.1428 18.9436 12.4073 19.7148 11.5 19.7148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.d999dc9722017e463407c0cdcea9fd29.svg";
export { ForwardRef as ReactComponent };